export default function ControlLabel(theme) {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '.MuiRadio-root': {
            alignSelf: 'flex-start' // required for Radio to have a caption text
          },
          '.MuiRadio-root + .MuiTypography-root': {
            alignSelf: 'flex-start', // required for Radio to have a caption text
            marginTop: theme.spacing(1) // required for Radio to have a caption text
          }
        },
        label: {
          // ...theme.typography.body2
          flexGrow: 1
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: theme.spacing(1)
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.disabled
        }
      }
    }
  };
}
